var React = require('react');

function MintFoxLogoStroke (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#fff","key":0},[React.createElement("path",{"strokeWidth":"8","d":"M185.359 104.558h79.506","key":0}),React.createElement("path",{"d":"M340.561 168.818l-77.632-64.147 77.632-64.147v128.293zm-230.946 0l77.632-64.147-77.632-64.147v128.293z","strokeWidth":"7","key":1}),React.createElement("path",{"strokeWidth":"8","d":"M340.49 169.046L234.031 389.761l156.508-167.236-50.049-53.479zm-230.998.018l-50.031 53.461L215.92 389.71 109.492 169.063z","key":2})]),React.createElement("path",{"fill":"#62c5bb","fillRule":"evenodd","stroke":"#62c5bb","d":"M224.979 409.475l-13.61-23.354h27.221l-13.61 23.354z","key":1})]);
}

MintFoxLogoStroke.defaultProps = {"viewBox":"0 0 450 450"};

module.exports = MintFoxLogoStroke;

MintFoxLogoStroke.default = MintFoxLogoStroke;
